import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@material-ui/core';

import useStyles from './useStyles';

const DesktopCalculationsResult = props => {
  const { mortgagePayment } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box my={4} width="100%">
      <Box display="flex">
        <Typography variant="h2" className={classes.text}>
          {`${t('components.MothlyPaymentCalculator.DesktopCalculationsResult.mortgagePayment')}: ${mortgagePayment}`}
        </Typography>
      </Box>
    </Box>
  );
};

DesktopCalculationsResult.propTypes = {
  mortgagePayment: PropTypes.string.isRequired,
};

export default DesktopCalculationsResult;



// WEBPACK FOOTER //
// ./src/sharedComponents/MothlyPaymentCalculator/components/DesktopCalculationsResult/DesktopCalculationsResult.js